import React from 'react';
import { Button, Modal, Form, Input, Select, message } from 'antd';
import { api, onPost } from '../../../../core/api3';

const Option = Select.Option;

class QuantRobotEditView extends React.Component {

    constructor() {
        super();
        this.state = {
        }
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
    }

    onClick(type) {
        switch (type) {
            case 'confirm':
                this.props.form.validateFieldsAndScroll((error, fields) => {
                    if (error) {
                        return;
                    }
                    onPost(api.addQuantRobot.url, api.addQuantRobot.params(fields.name, fields.strategy)).then(response => {
                        if (response === undefined) {
                            return;
                        }
                        message.success('添加成功');
                        this.props.onModalFinish();
                    });
                });
                break;
            default:
                break;
        }
    }

    render() {
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 }
        };
        let quantRobotStrategys = this.props.quantRobotStrategys.map(quantRobotStrategy => {
            return <Option key={quantRobotStrategy.key}>{quantRobotStrategy.describe}</Option>;
        });
        return (
            <Modal title="添加" visible={true} okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }} onCancel={this.props.onModalCancel}>
                <Form>
                    <Form.Item {...formItemLayout} label="实盘名称">
                        {this.props.form.getFieldDecorator('name', {
                            rules: [{ required: true, message: '请输入实盘名称' }]
                        })(
                            <Input placeholder="请输入实盘名称" maxLength="20" />
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label="实盘策略">
                        {this.props.form.getFieldDecorator('strategy', {
                            rules: [{ required: true, message: '请选择实盘策略' }]
                        })(
                            <Select placeholder="请选择实盘策略">
                                {quantRobotStrategys}
                            </Select>
                        )}
                    </Form.Item>
                    <Form.Item wrapperCol={{ span: 20, offset: 4 }}>
                        <Button type="primary" onClick={() => this.onClick('confirm')}>添加</Button>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }

}

const QuantRobotEditModal = Form.create()(QuantRobotEditView);
export default QuantRobotEditModal;


// WEBPACK FOOTER //
// ./src/page/jsx/coin/quant/QuantRobotEditModal.jsx